import src from "IMAGE";
export default { src, width: 187, height: 130, blurWidth: 0, blurHeight: 0};
